/*global jQuery */
(function($) {

  'use strict';

  var jsonString = {};

  $(function() {
    $('#datetimepicker1').datetimepicker({
      showClear: true,
      showClose: true,
      format: 'DD/MM/YYYY'
    });
    $('#datetimepicker2').datetimepicker({
      useCurrent: false, //Important! See issue #1075
      showClear: true,
      showClose: true,
      format: 'DD/MM/YYYY'
    });
    $('#datetimepicker1').on('dp.change', function(e) {
      $('#datetimepicker2').data('DateTimePicker').minDate(e.date);
    });
    $('#datetimepicker2').on('dp.change', function(e) {
      $('#datetimepicker1').data('DateTimePicker').maxDate(e.date);
    });
  });

  var attivaModal = function(message, buttons, idButtons, callBack) {
    $('.modal-body p').hide();
    $('.modal-body p').html(message);
    $('.modal-body p').show();

    if (!$('.modal').hasClass('in')) {
      $('.modal').modal('show');
    }

    $('.modal-footer').html('');

    if (typeof buttons !== 'undefined' && buttons !== null) {
      if (buttons.length > 0) {
        $.each(buttons, function(index, value) {
          if (idButtons[index] === '') {
            $('.modal-footer').append('<button type="button" class="btn btn-default" data-dismiss="modal">' + value + '</button>');
          } else {
            $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
          }
        });
      }
    }
    if (typeof callBack === 'function') {
      callBack();
    }
  };

  /* validation form disponibilita */

  $('body').on('click', '.invia-dispo', function() {
    var validator = $('#form-disponibilita').validate({
      focusInvalid: false,
      onkeyup: false,
      onfocusout: false,
      errorElement: 'p',
      errorPlacement: function(error) {
      var tmpl = '<span class="glyphicon glyphicon-remove-circle" style="font-size: 70px; color:orange;"></span><br><br>' +
        '<h4>' + $(error).html() + '</h4><br>';

      attivaModal(tmpl, ['Chiudi'], ['']);

      $('div#errors').show();
      if ($('div#errors').html() === '') {
        error.appendTo('div#errors');
      }
    },
      rules: {
        nome: {
          required: true
        },
        cognome: {
          required: true
        },
        captcha: {
          required: true
        },
        telefono: {
          required: true
        },
        arrivo: {
          required: true
        },
        partenza: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        cittadinanza: {
          required: true
        },
        unita_abitativa: {
          required: true
        },
        check_privacy: {
          required: true
        },
        eta_bambini: {
          required: function(element){
            return $("#bambini").val() != "0";
          }
        }
      },
      messages: {
        nome: {
          required: document.msgError['nome']
        },
        cognome: {
          required: document.msgError['cognome']
        },
        captcha: {
          required: document.msgError['captcha']
        },
        telefono: {
          required: document.msgError['telefono']
        },
        arrivo: {
          required: document.msgError['arrivo']
        },
        partenza: {
          required: document.msgError['partenza']
        },
        check_privacy: {
          required: document.msgError['privacy']
        },
        cittadinanza: {
          required: document.msgError['cittadinanza'],
        },
        unita_abitativa: {
          required: document.msgError['unita_abitativa'],
        },
        eta_bambini: {
          required: document.msgError['eta_bambini'],
        },
        email: {
          required: document.msgError['email'],
          email: document.msgError['emailCorretta']
        }
      },
      invalidHandler: function() {
        $('div#errors').html('');
      }
    });

    var arr = {};

    arr.nome = $('#nome').val();
    arr.cognome = $('#cognome').val();
    arr.email = $('#email').val();
    arr.telefono = $('#telefono').val();
    arr.cellulare = $('#cellulare').val();

    arr.cittadinanza = $('#cittadinanza').val();
    arr.indirizzo = $('#indirizzo').val();
    arr.cap = $('#cap').val();
    arr.citta = $('#citta').val();
    arr.provincia = $('#provincia').val();

    arr.adulti = $('#adulti').val();
    arr.bambini = $('#bambini').val();
    arr.eta_bambini = $('#eta_bambini').val();

    arr.unita_abitativa = $('#unita_abitativa').val();
    arr.arrivo = $('#arrivo').val();
    arr.partenza = $('#partenza').val();

    arr.messaggio = $('#messaggio').val();
    arr.privacy = $('#privacy').val();
    arr.captcha = $('#captcha').val();

    //alert(arr.unita_abitativa);

    jsonString = JSON.stringify(arr);

    if (validator.form()) {

      var tmpl = '<span class="glyphicon glyphicon-question-sign" style="font-size: 70px; color:orange;"></span><br><br>' +
      document.msg['conferma'] + '<h3>' + $('#unita_abitativa').find('option:selected').html() + '<br><br>' + $('#arrivo').val() + ' - ' + $('#partenza').val() + '</h3><br><br>';
      attivaModal(tmpl, [document.btu['conferma'], document.btu['chiudi']], ['conferma-invio', ''], null);

      return false;
    }
  });

  $('body').on('click', '#modal-action-conferma-invio', function() {
    var tmpl = '<span class="glyphicon glyphicon-time" style="font-size: 70px; color:orange;"></span><br><br>' +
      '<h4>' + document.msg['elaborazione'] + '</h4><br><br>';
      attivaModal(tmpl, null, null);

      $.ajax({
        url: '/ajax/function.php',
        method: 'POST',
        data: {
          'action': 'invia-prenotazione',
          'obj': jsonString,
          'lin': document.language
        },
        success: function(ret) {
          var arr = ret.split('|');
          var tmpl = '';

          if (arr[0] === '1') {
            tmpl = '<span class="glyphicon glyphicon-send" style="font-size: 70px; color:green;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
            
            $('input.form-control').val('');
            $('#messaggio').val('');
            $('#cittadinanza').val('');
            $('#unita_abitativa').val('');
            setTimeout(function(){ $('.modal').modal('hide'); }, 3000);

          } else {
            tmpl = '<span class="glyphicon glyphicon-error" style="font-size: 70px; color:red;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
            setTimeout(function(){ $('.modal').modal('hide'); }, 5000);
          }
          attivaModal(tmpl, [document.btu['chiudi']], [''], null);
        }
      });
  });


  $('#unita_abitativa').on('change', function() {
    var selected = $(this).find('option:selected').html();
    var tmp = $('h1').html().split(' - ');
    $('h1').html(tmp[0] + ' - ' + selected);
  });

}(jQuery));
